// istanbul ignore next
export const ENROLLMENT_HEADER = 'CHECKLESS PAYMENT';

export const RESERVATION_SETTINGS_HEADER = 'YOUR RESERVATION';

export const LEAVE_RECEIPTS_BEHIND_HEADER = 'Leave paper receipts behind.';

export const SELECT_GRATUITY_HEADER = 'Select your Gratuity.';

export const SAVE_YOUR_CARD_HEADER = 'Save your card ahead of time';

export const ADD_CARD_HEADER =
  'Are you sure you want to replace your saved card?';

export const REPLACE_YOUR_CARD_HEADER = 'Replace your card';

export const REMOVE_CARD_HEADER = 'Are you sure?';

export const REMOVE_CARD_SUBHEADER =
  'You will need to provide a payment method at the restaurant. You can re-enroll at any time before your reservation.';

export const LAST_STEP_HEADER = 'Last step';

export const FINAL_SCREEN_HEADER = 'Everything is taken care of';

export const ENROLLMENT_SUBHEADER =
  "We'll take care of the bill at the end of the meal. You'll be able to leave whenever you're ready — no more waiting for the check.";

export const TIP_SUBHEADER =
  'Choose a gratuity amount to apply to your check - no need to calculate it at the table. You can change this for up to an hour after your visit.';

export const TIP_NOT_ADJUSTABLE_SUBHEADER =
  'Choose a gratuity amount to apply to your check - no need to calculate it at the table.';

export const SAVE_PAYMENT_SUBHEADER =
  "Save your payment method now and leave the restaurant whenever you're ready - we'll take care of everything else.";

export const CHOOSE_HOW_TO_PAY_SUBHEADER =
  "Choose how you want to pay. Leave the restaurant whenever you're ready and we'll charge your card automatically.";

export const SAVE_YOUR_CARD_SUBHEADER =
  "Save your card to pay for the check at the end of your visit. Leave the restaurant whenever you're ready and we'll charge your card automatically.";

export const FINAL_SCREEN_SUBHEADER =
  "When you arrive, we'll send you a text with a link to your bill. You can review it at any time during your visit.";

export const GRATUITY_HELPER =
  'You can change this for up to an hour after your visit.';

export const OUR_MENU_SUBHEADER =
  "Restaurant's constantly evolving menu takes traditional techniques and global ingredients to unexpected places.";

export const CHECKLESS_BILL_SPLITTING_SUBHEADER =
  "Checkless Payments handles bill splitting automatically. Add your card now so your party can leave whenever you're finished—no waiting for the check.";
